const getToken = () => localStorage.getItem('SESSION_TOKEN');
const putToken = (token) => localStorage.setItem('SESSION_TOKEN', token);

export { getToken, putToken };
